var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn md__btn-primary float-right",on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_vm._v(" Guardar ")])
}
var staticRenderFns = []

export { render, staticRenderFns }